<template>
  <div>
  <care-card
      v-for="(aCareCard, j) in careCards"
      style="margin-bottom: 15px"
      :care-card="aCareCard"
      :heartbeat="heartbeat"
      :profile="profile"
      :doc="doc"
      :apps="apps"
      :section="section"
      :planid="planid"
      :key="`cc-${j}`"
  />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CareCard from "./card";
export default {
  name: "HeartBeat_CarePlan_Block",
  components: {
    CareCard
  },
  created() {},
  beforeMount() {},
  mounted() {},
  props: {
    heartbeat: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    apps: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    section: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    planid: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({}),
    sectionText() {
      return this.info && Array.isArray(this.info)
        ? this.info.join(" ")
        : this.info;
    },
    careCards() {
      return this.info && Array.isArray(this.info)
          ? this.info : [];
    }
  },
  methods: {
    handleEditToggle() {
      this.isEditMode != this.isEditMode;
    }
  },
  data() {
    return {
      info:
        this.section && this.section.info && Array.isArray(this.section.info)
          ? this.section.info
          : [this.section.info],
      sectionId: this.section && this.section.id ? this.section.id : "none",
      carePlanDocId: this.doc && this.doc.id ? this.doc.id : null,
      isEditMode: false
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>
